import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kw-spinner',
  templateUrl: './kw-spinner.component.html',
  styleUrls: ['./kw-spinner.component.scss']
})
export class KwSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
